import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import AppLayout from '@/layout/app-layout.vue'
import LandingPageLayout from '@/modules/landing/Landing.vue';

// import RouteViewComponent from './route-view.vue'
import { permissionService } from '@/shared/services/permission-service'
import adminRoutes from './adminRoutes';
import Report from '@/modules/report/report.vue';
import Download from '@/modules/download/Download.vue';
import ErrorPage from '@/pages/404-pages/VaPageNotFound.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: "/:catchAll(.*)",
    redirect: { name: 'dashboard' }
  },
  {
    path: '/error',
    component: ErrorPage
  },
  {
    name: 'Home',
    path: '/',
    component: LandingPageLayout

  },
  {
    name: 'portal',
    path: '/portal',
    component: AppLayout,
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('@/pages/admin/dashboard/Dashboard.vue'),
        // component: () => import('@/modules/dashboard/Dashboard_.vue'),
        meta: {
          requiresAuth: true,
          requiresPermission: 'view_dashboard'
        }
      },
      ...adminRoutes,
      // {
      //   name: 'benchmark_report',
      //   path: 'benchmark_report',
      //   component: () => import('@/modules/benchmark/Benchmark.vue'),
      //   meta: {
      //     requiresAuth: true,
      //     breadcrumb: [
      //       { name: 'BENCHMARK Tools' }
      //     ],
      //   }
      // },
      {
        name: 'export',
        props: true,
        path: 'export/:export_id?',
        component: () => import('@/modules/powerbi-export/PowerbiExport.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'Export Tools' }
          ]
        }
      },
      {
        name: 'school-list',
        path: 'school-list',
        component: () => import('@/modules/schools/school-list.vue'),
        meta: {
          requiresAuth: true,
          breadcrumb: [
            { name: 'School List' }
          ],
          requiresPermission: 'view_all_schools'
        }
      },
      // {
      //   name: 'benchmark tools',
      //   path: 'benchmark',
      //   component: () => import('@/modules/benchmark/Benchmark.vue'),
      //   meta: {
      //     requiresAuth: true
      //   }
      // },
      {
        path: 'benchmark_report',
        name: 'benchmark_report',
        component: () => import('@/modules/benchmark-report/benchmark-report.vue'),
        meta: {
          breadcrumb: [
            { name: 'BENCHMARK REPORT' }
          ],
          requiresPermission: 'view_benchmark_report'
        }
      },
      {
        name: 'maps',
        path: 'maps',
        component: () => import('@/modules/maps/maps.vue'),
        meta: {
          requiresAuth: true,
          requiresPermission: 'view_demographics'
        }
      },
      {
        path: 'permission-denied',
        name: 'permission-denied',
        component: import('@/modules/permission-denied/PermissionDenied.vue'),
        meta: {
          breadcrumb: [
            { name: '' }
          ]
        }
      },
      {
        name: 'report',
        path: 'report/:codename?',
        props: true,
        component: Report,
        meta: {
          breadcrumb: [
            { name: 'Report' }
          ],
          requiresReportPermission: true
        }
      },
      {
        name: 'download',
        path: 'download/:download_id?',
        component: Download,
        props: true,
        meta: {
          breadcrumb: [
            { name: 'Download' }
          ],
          requiresDownloadPermission: true
        }
      },
      {
        name: 'Students',
        path: 'students',
        props: true,
        component: Report,
        children: [
          {
            name: 'student-insight',
            path: 'insight',
            component: () => import('@/pages/404-pages/VaPageNotFound.vue'),
            meta: {
              requiresAuth: true
            }
          },
          {
            name: 'application-management',
            path: 'application-management',
            component: () => import('@/pages/404-pages/VaPageNotFound.vue'),
            meta: {
              requiresAuth: true
            }
          },
          {
            name: 'Enrollment Prediction',
            path: '',
            component: () => import('@/pages/404-pages/VaPageNotFound.vue'),
            meta: {
              requiresAuth: true
            }
          }
        ]
      },
      {
        name: 'Staff Management',
        path: 'staff',
        props: true,
        component: Report,
        children: [
          {
            name: 'staff-insight',
            path: 'staff-insight',
            component: () => import('@/pages/404-pages/VaPageNotFound.vue'),
            meta: {
              requiresAuth: true
            }
          }
        ]
      },
      {
        name: 'Performance Management',
        path: 'performance',
        props: true,
        component: Report,
        children: [
          {
            name: 'student-performance',
            path: 'student',
            component: () => import('@/pages/404-pages/VaPageNotFound.vue'),
            meta: {
              requiresAuth: true
            }
          },
          {
            name: 'teacher-performance',
            path: 'teacher',
            component: () => import('@/pages/404-pages/VaPageNotFound.vue'),
            meta: {
              requiresAuth: true
            }
          },
          {
            name: 'department-management',
            path: 'department',
            component: () => import('@/pages/404-pages/VaPageNotFound.vue'),
            meta: {
              requiresAuth: true
            }
          },
          {
            name: 'school-management',
            path: 'school',
            component: () => import('@/pages/404-pages/VaPageNotFound.vue'),
            meta: {
              requiresAuth: true
            }
          }
        ]
      }
    ],
    meta: {
      requiresAuth: true,
    }
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  //  mode: process.env.VUE_APP_ROUTER_MODE_HISTORY === 'true' ? 'history' : 'hash',
  routes
})

router.resolve({ name: 'report', params: { codename: 'codename' } }).href

router.beforeEach((to, from, next) => {
  // if (!to.matched.some(record => record.meta.requiresPermission)) {
  //   next('/portal/permission-denied');
  // }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    const getUserFromSession = sessionStorage.getItem('user') || '';
    const user = getUserFromSession ? JSON.parse(getUserFromSession) : null;
    if (user && user.accessToken) { //if the user object is available in the session Storage and accessToken available
      //Now check permission
      const rp = to.meta.requiresPermission;
      const rrp = to.meta.requiresReportPermission;
      if (rp) {
        if (true === permissionService.hasPermission(rp)) {
          next();
        }
        else {
          next('/portal/permission-denied');
        }
      }
      else if (rrp) {
        if (true === permissionService.hasReportPermission(to)) {
          next();
        }
        else {
          next('/portal/permission-denied');
        }
      }
      else {
        next()
      }

    } else {
      next('/') //redirect to landing page
    }
  } else {
    next()
  }

  // next();
})

export default router
